export const TIMELINE_COLUMN_WIDTH = 483;
export const TIMELINE_HEADER_HEIGHT = 42;
